import dayjs from "dayjs";
import { ProductType } from "../../types";
import { ProductInfo } from "../../types";
import { InsuranceSelector } from "../InsuranceSelector";
import { CarInsuranceSelector } from "../CarInsuranceSelector";
import { stripHtml } from "@/utils/format";

interface ProductCardProps {
  productInfo: ProductInfo;
  productType: ProductType;
  basePrice: number;
  /** 成人单价 */
  adultPrice?: number;
  /** 儿童单价 */
  childPrice?: number;
  /** 车辆金额（来自订单详情，优先显示） */
  carAmount?: string;
  /** 日租金（来自订单详情） */
  dailyPrice?: string;
  /** 车辆名称（来自订单详情） */
  carTitle?: string;
  /** 取车地点（来自订单详情） */
  pickupLocation?: string;
  /** 租赁天数（来自订单详情） */
  rentDays?: number;
  /** 保险类型文字（来自订单详情） */
  insuranceTypeText?: string;
  /** 自定义封面图（优先于 productInfo.image） */
  coverImage?: string;
  insurance: string;
  onInsuranceChange: (v: string) => void;
  carExtraUpgrade: boolean;
  onCarExtraToggle: () => void;
}

export function ProductCard({
  productInfo,
  productType,
  basePrice,
  adultPrice,
  childPrice,
  carAmount,
  dailyPrice,
  carTitle,
  pickupLocation,
  rentDays,
  insuranceTypeText,
  coverImage,
  insurance,
  onInsuranceChange,
  carExtraUpgrade,
  onCarExtraToggle,
}: ProductCardProps) {
  const displayName = carTitle || productInfo.name;
  const isHotel = productType === "hotel";
  const isTour = productType === "tour";
  const unitLabel = isHotel ? "晚" : "天";
  const locationLabel = isHotel ? "入住" : (isTour ? "出发" : "取车");
  const priceLabel = dailyPrice ? `¥${dailyPrice}/${unitLabel}` : `¥${basePrice}`;

  // 底部标签行：地点 / 天数(晚数)
  const tags: string[] = [];
  // 清洗后端字段里夹带的 HTML 标签
  const safePickup = stripHtml(pickupLocation);
  if (safePickup) tags.push(`${locationLabel}：${safePickup}`);
  if (rentDays) tags.push(`${rentDays}${unitLabel}`);
  if (insuranceTypeText && !isHotel) tags.push(insuranceTypeText);
  const tagLine = tags.join(" · ");

  return (
    <div className="rounded-2xl p-4" style={{ background: "#fff" }}>
      <div className="flex items-center gap-3">
        {/* 产品首图 */}
        <div className="w-14 h-14 rounded-xl overflow-hidden flex-shrink-0">
          <img
            src={coverImage || productInfo.image}
            alt={displayName}
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-sm font-bold text-gray-900">
            {displayName}
          </div>
          {!isTour && (
            <div className="text-xs text-gray-500 mt-0.5">
              {priceLabel}
            </div>
          )}
          {tagLine && (
            <div className="text-xs text-gray-400 mt-0.5">{tagLine}</div>
          )}
        </div>
        <div className="text-right flex-shrink-0">
          {productType === "tour" && (adultPrice != null || childPrice != null) ? (
            <div className="flex flex-col items-end gap-0.5">
              {adultPrice != null && (
                <div className="text-xs text-gray-400">成人 ¥{adultPrice}</div>
              )}
              {childPrice != null && (
                <div className="text-xs text-gray-400">儿童 ¥{childPrice}</div>
              )}
            </div>
          ) : (
            <div className="text-base font-bold" style={{ color: "#EF4444" }}>
              ¥{carAmount || basePrice}
            </div>
          )}
        </div>
      </div>
      {/* 保险选择 */}
      {/* {productType === "car" ? (
        <CarInsuranceSelector
          extraUpgrade={carExtraUpgrade}
          onToggle={onCarExtraToggle}
        />
      ) : (
        <InsuranceSelector
          value={insurance as any}
          onChange={onInsuranceChange as any}
        />
      )} */}
    </div>
  );
}
